import { render, staticRenderFns } from "./land.vue?vue&type=template&id=05882b2c&scoped=true&"
import script from "./land.vue?vue&type=script&lang=js&"
export * from "./land.vue?vue&type=script&lang=js&"
import style0 from "./land.vue?vue&type=style&index=0&id=05882b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05882b2c",
  null
  
)

export default component.exports